import React, { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse as CollapseComponent, ListItem, ListItemText, Tooltip } from '@mui/material';
import clsx from 'clsx';
import useStyles from './styles';
import { ICollapse } from './types';
import { AccordionReportHeader } from '../AccordionReportHeader';

const Collapse = ({ 
  title, 
  reportName, 
  children, 
  unmountOnExit = false, 
  disabled = false,
  disabledTooltip = 'This content is currently not available',
  isOpen: externalIsOpen,
  onToggle
}: ICollapse) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);  
  const isOpen = externalIsOpen ?? internalIsOpen;
  const classes = useStyles();

  const handleCollapse = () => {
    if (!disabled) {
      const newState = !isOpen;
      
      if (externalIsOpen !== undefined && onToggle) {
        onToggle(newState);
      } else {
        setInternalIsOpen(newState);
      }
    }
  };

  const content = (
    <>
      {reportName && <AccordionReportHeader reportName={reportName} />}
      <ListItem 
        component="li" 
        className={clsx(classes.item, { [classes.disabled]: disabled })} 
        onClick={handleCollapse}
      >
        <ListItemText className={clsx(classes.itemText)} primary={title} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <CollapseComponent in={isOpen} timeout="auto" unmountOnExit={unmountOnExit} style={{ width: '100%' }}>
        {children}
      </CollapseComponent>
    </>
  );

  return disabled ? (
    <Tooltip title={disabledTooltip}>
      <div className={classes.tooltipContainer}>
        {content}
      </div>
    </Tooltip>
  ) : content;
};

export default Collapse;
